import { render, staticRenderFns } from "./ClientSyncLog.vue?vue&type=template&id=8a8da10a&scoped=true"
import script from "./ClientSyncLog.vue?vue&type=script&lang=ts"
export * from "./ClientSyncLog.vue?vue&type=script&lang=ts"
import style0 from "./ClientSyncLog.vue?vue&type=style&index=0&id=8a8da10a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8da10a",
  null
  
)

export default component.exports